const BlockView = require('views/block/base-block-view');
const ef = require('ef/ef');
const ContentProvider = require('services/content-provider');
const AhoyService = require('services/ahoy-service');
import { KeybindingService, keys } from 'services/keybinding-service';
const LocaleService = require('services/locale-service');
import IconLoadService from 'services/icon-load-service';
import EmbeddedSurveyTemplate from 'views/block/embedded-survey/templates/embedded-survey';
const { Enter, Space, ArrowUp, ArrowDown} = keys;
const CHECKED_LABEL_CLASS = 'active';

const EmbeddedSurvey = BlockView.extend({
  template: EmbeddedSurveyTemplate,
  className: 'embedded-survey',
  initialize: function() {
    if(EF.options.local) {
      try {
        this.model.set('survey', new ef.Models.Survey(
          Object.assign(
            require(`local-data/surveys/${this.model.get('slug')}`),
            { slug: this.model.get('slug') },
            { question_headerlevel: this.model.get('question_headerlevel') }
          )
        ));
        this.model.get('survey').initResponseSet(
          { success: responseSet => this.model.set('responseSet', responseSet) }
        );
        this.loadIcons();
      } catch (e) {
        console.error(`Could not find local data in local-data/surveys/${this.model.get('slug')}`);  //eslint-disable-line no-console
      }
    } else {
      this.model.set('survey', new ef.Models.Survey({
        slug: this.model.get('slug'),
        question_headerlevel: this.model.get('question_headerlevel')
      }));
      ContentProvider.SurveyService.getSurvey(this)
        .then(() => this.processQuestions())
        .then(() => this.loadIcons());
    }
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function() {
    this.delegate('click', 'input[type="checkbox"]', function(e) {
      const $checkbox = $(e.currentTarget);
      if ($checkbox.is(':checked')) {
        $checkbox.next().addClass(CHECKED_LABEL_CLASS);
      } else {
        $checkbox.next().removeClass(CHECKED_LABEL_CLASS);
      }
    });

    this.delegate('click', 'label[role="radio"]', function(e) {
      const $radio = $(e.currentTarget);
      if ($radio.not(':checked')) {
        $radio
          .siblings('label')
          .removeClass(CHECKED_LABEL_CLASS)
          .attr('aria-checked', false);
        $radio
          .addClass(CHECKED_LABEL_CLASS)
          .attr('aria-checked', true);
      }
    });

    this.delegate('keydown', '.choices__label', e => {
      const $label = $(e.target);
      KeybindingService.with(e).bind(
        [Enter, Space],
        () => {
          e.preventDefault();
          $label.trigger('click');
          $label.trigger('focus');
        },
        [ArrowUp],
        () => {
          e.preventDefault();
          const hasPrev = $label.prevAll('.choices__label').length > 0;
          if (hasPrev) {
            $label
              .prevAll('.choices__label')
              .first()
              .trigger('focus');
          }
        },
        [ArrowDown],
        () => {
          e.preventDefault();
          const hasNext = $label.nextAll('.choices__label').length > 0;
          if (hasNext) {
            $label
              .nextAll('.choices__label')
              .first()
              .trigger('focus');
          }
        }
      );
    });
  
    if (EF.options.local) {
      this.processQuestions();
    }
  },
  loadIcons: function() {
    if(this.model.get('survey')) {
      this.model.get('survey').get('sections').forEach(({ questions }) => {
        questions.forEach(({ icon_prefix, icon_name, icon_name_selected, icon_size, response_type, answers }) => {
          let iconName, iconNameSelected;
          iconName = icon_name || response_type === 'multiple_selection' ? 'fa-square' : 'fa-circle';
          iconNameSelected = icon_name_selected || response_type === 'multiple_selection' ? 'fa-check-square' : 'fa-dot-circle';
          answers.forEach(({ id }, index) => {
            const index_id = (index === 0) ? id : `${id}-${index}`;
            IconLoadService.applyIcon(iconName, index_id, icon_size, (icon_prefix || 'far'));
            IconLoadService.applyIcon(iconNameSelected, index_id, icon_size, (icon_prefix || 'far'));
          });
        });
      });
    }
  },
  processQuestions: function() {
    const questions = (this.model.get('survey').get('sections')[this.model.get('section_number')].questions);
    if(questions.length === 1) {
      this.delegate('change', '.answer input', e => {
        this.simulateAnswerSeletion(e);
      });

    } else {
      const $btnSubmit = $('#submitQuestions');
      $btnSubmit.attr('disabled', 'disabled');
      let selectedQuestions = [];
      let multipleAnswers = [];

      const inputs = ($('#submitQuestions').prev().find("[class*='btn-group-']"));
      let total = 0;
      this.delegate('change', '.answer input', e => {
        const answer = this.getAnswers(e, true);
        const questions = this.model.get('survey').get('sections')[this.model.get('section_number')].questions;

        const question = _.find(questions, function(question) {
          return question.id == e.target.dataset.questionId;
        });

        if(question.response_type === 'multiple_selection') {
          if($(e.target).parent().hasClass('active')) {
            total += 1;

            if(multipleAnswers.length === 0) {
              multipleAnswers[e.target.dataset.questionId] = [e.target.dataset.answerId];
            } else {
              if(multipleAnswers.indexOf(e.target.dataset.answerId) === -1) {
                if(multipleAnswers[e.target.dataset.questionId] === undefined) {
                  multipleAnswers[e.target.dataset.questionId] = [e.target.dataset.answerId];
                } else {
                  multipleAnswers[e.target.dataset.questionId].push(e.target.dataset.answerId);
                }
              }
            }
          } else {
            const index = multipleAnswers[e.target.dataset.questionId].indexOf(e.target.dataset.answerId);
            multipleAnswers[e.target.dataset.questionId].splice(index, 1);
            total = total === 0 ? 0 : total -= 1;
          }
        } else {
          if(selectedQuestions.length === 0) {
            total += 1;
            selectedQuestions.push({ answer_id: answer.context.dataset.answerId, question_id: answer.context.dataset.questionId });
          } else {
            if(selectedQuestions.findIndex(elem => elem.question_id === answer.context.dataset.questionId) === -1) {
              total += 1;
              selectedQuestions.push({ answer_id: answer.context.dataset.answerId, question_id: answer.context.dataset.questionId });
            } else {
              const index = selectedQuestions.findIndex(elem => elem.question_id === answer.context.dataset.questionId);
              selectedQuestions.splice(index, 1, { answer_id: answer.context.dataset.answerId, question_id: answer.context.dataset.questionId });
            }
          }
        }
        if(total >= questions.length) {
          $btnSubmit.removeAttr('disabled');
        } else if(!this.model.get('responseSet').get('allow_answer_change')) {
            $btnSubmit.attr('disabled', 'disabled');
        }
      });

      this.delegate('click', '#submitQuestions', () => {

        const answerArray = [];
        for(let i = 0; i < multipleAnswers.length; i++) {
          if(multipleAnswers[i] !== undefined) {
            answerArray.push({
              question_id: i,
              answers: multipleAnswers[i]
            });
          }
        }
        const finalAnswers = answerArray.concat(selectedQuestions);
        if(this.model.has('responseSet')) {
          AhoyService.track('embedded-survey', { action: 'save response', slug: this.model.get('slug'), question: finalAnswers });
          const options = {
            multipleQuestion: true
          };
          ContentProvider.SurveyService.saveSurveyResponse(this, finalAnswers, options);
          if(!this.model.get('responseSet').get('allow_answer_change')) {
            $btnSubmit.attr('disabled', 'disabled');
            for(let i = 0; i < inputs.length; i++) {
              $(inputs[i]).find('label.answer').addClass('disabled').attr('tabindex', -1);
              $(inputs[i]).find('input.answer').prop('disabled', true);
            }
          }
          
          AhoyService.track('embedded-survey', { action: 'completed', slug: this.model.get('slug') });
          this.model.set('completed', true);
          this.readyToGo();
        }
      });

    }
  },

  getAnswers(e, multiple = false) {

    let answers = $(e.target).closest("[class*='btn-group-']");
    let option = $(e.target);

    const ariaLabel = LocaleService.t('surveyAccessibility.optionLabel') + ' ' +
      option.data('index') + ' ' +
      LocaleService.t('surveyAccessibility.checkedOptionSurfix') + ': ' +
      LocaleService.t('surveyAccessibility.disabledOptions');
    $(answers).trigger('focus');
    if(!multiple && !this.model.get('responseSet').get('allow_answer_change')) {
      $(answers).find('label.answer').addClass('disabled').attr('tabindex', -1);
      $(answers).find('.answer input').prop('disabled', true);
    }
    return $(answers);
  },

  simulateAnswerSeletion(e) {
    this.getAnswers(e);
    if(this.model.has('responseSet')) {
      AhoyService.track('embedded-survey', { action: 'save response', slug: this.model.get('slug'), question: e.target.dataset.questionId, answer: e.target.dataset.answerId });
      ContentProvider.SurveyService.saveSurveyResponse(this, e.target.dataset);
    }
    var allQuestionsAnswered = this.model.get('survey').get('sections')[this.model.get('section_number')].questions.every(question => {
      if(question.id.toString() === e.currentTarget.dataset.questionId.toString()) {
        question.answered = true;
      }
      return question.answered;
    });
    if(allQuestionsAnswered) {
      AhoyService.track('embedded-survey', { action: 'completed', slug: this.model.get('slug') });
      this.model.set('completed', true);
      this.readyToGo();
    }
  },
  complete: function() {
    ContentProvider.SurveyService.refreshResponseSet(this.model.get('slug'));
    this.trigger('block:state:completed', this);
  }
});

module.exports = EmbeddedSurvey;

